import React from 'react';
import { Typography } from '@mui/material';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { SettingDisplay } from 'lib/SettingDisplay';

export const ComtrexSettingsDisplay: React.FC<IPointOfSaleSettingsProps> = ({ settings, locationId }) => (
    <>
        {/* Common Only */}
        {locationId === undefined && (
            <SettingDisplay label="Vendor Name">
                <Typography variant="body1">{settings?.comtrex?.vendorName}</Typography>
            </SettingDisplay>
        )}
        {/* Location Only */}
        {locationId !== undefined && (
            <>
                <SettingDisplay label="Host">
                    <Typography variant="body1">{settings?.comtrex?.host}</Typography>
                </SettingDisplay>
                <SettingDisplay label="Payment Type Id">
                    <Typography variant="body1">{settings?.comtrex?.paymentTypeId}</Typography>
                </SettingDisplay>
            </>
        )}
    </>
);
